import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppCustomPreloader } from './app-custom-preloader';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { AuthGuardService } from './Services/AuthGuard/auth-guard.service';
import { AuthGuardLoginService } from './Services/AuthGuard/authguard.login.service';
import { EntityDeatilPageGuard } from './Services/AuthGuard/entity-deatil-page-guard';
import { EstablishmentPageGuard } from './Services/AuthGuard/establishment-page-guard';


const routes: Routes = [

	{ path: '',
    redirectTo: 'lender/authentication/login',
    pathMatch: 'full' },
	{
		path: 'home',
		loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
		canActivate: [AuthGuardLoginService, AuthGuardService],
	},
	{
		path: 'lender',
		loadChildren: () => import('./lender/lender.module').then(m => m.LenderModule),
		canActivate: [AuthGuardLoginService, AuthGuardService],
	},
	{
		path: 'lender/:eId',
		loadChildren: () => import('./lender/lender.module').then(m => m.LenderModule),
		canActivate: [AuthGuardLoginService, AuthGuardService],
	},
	{
		path: 'lender/authentication',
		loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule),
		canActivate: [AuthGuardLoginService],
	},
	{
		path: 'lender/:id',
		loadChildren: () => import('./lender/lender.module').then(m => m.LenderModule),
		canActivate: [AuthGuardLoginService],
	},
	{
		path: 'establishment',
		loadChildren: () => import('./establishment/establishment.module').then(m => m.EstablishmentModule),
		canActivate: [AuthGuardLoginService, AuthGuardService,EstablishmentPageGuard],
	},
	{
		path: 'getconsent',
		loadChildren: () => import('./order/order.module').then(m => m.OrderModule),
		canActivate: [AuthGuardLoginService, AuthGuardService],
	},
	{
		path: 'getborrowerdetails',
		loadChildren: () => import('./place-order-borrower/place-order-borrower.module').then(m => m.PlaceOrderBorrowerModule),
	},
	{
		path: 'loginGstBorrower',
		loadChildren: () => import('./login-gst-borrower/login-gst-borrower.module').then(m => m.LoginGstBorrowerModule),
	},
	{
		path: 'corpository/user',
		data: { preload: true, delay: true },
		loadChildren: () => import('./user/user.module').then(m => m.UserModule),
		canActivate: [AuthGuardService, AuthGuardLoginService]
	},
	{
		path: 'orderDetail',
		loadChildren: () => import('./entity-detail-page/entity-detail-page.module').then(m => m.EntityDetailPageModule),
		canActivate: [AuthGuardLoginService, AuthGuardService,EntityDeatilPageGuard],
	},
	{
		path:'accessDenied',
		loadChildren:() => import('./access-denied/access-denied.module').then(m =>m.AccessDeniedModule),
	},
	{
		path: '**',
		component: PagenotfoundComponent
	},
];

@NgModule({
	// imports: [RouterModule.forRoot(routes)],
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: AppCustomPreloader })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
